export default "__VITE_ASSET___XrbgDPK__"